// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-menu-button {
  display: none;
  margin-right: 8px;
  background: none !important;
  border: none !important;
  border-radius: 0 !important;
  padding: 8px !important;
  width: auto !important;
  height: auto !important;
}

.mobile-menu-button:hover {
  background: none !important;
}

/* Show mobile menu button only on mobile */
@media (max-width: 768px) {
  .mobile-menu-button {
    display: flex !important;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/MobileMenuButton/MobileMenuButton.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,2CAA2C;AAC3C;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".mobile-menu-button {\n  display: none;\n  margin-right: 8px;\n  background: none !important;\n  border: none !important;\n  border-radius: 0 !important;\n  padding: 8px !important;\n  width: auto !important;\n  height: auto !important;\n}\n\n.mobile-menu-button:hover {\n  background: none !important;\n}\n\n/* Show mobile menu button only on mobile */\n@media (max-width: 768px) {\n  .mobile-menu-button {\n    display: flex !important;\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
